import { render, staticRenderFns } from "./authorizedCertify.vue?vue&type=template&id=60b0a574&scoped=true"
import script from "./authorizedCertify.vue?vue&type=script&lang=js"
export * from "./authorizedCertify.vue?vue&type=script&lang=js"
import style0 from "./authorizedCertify.vue?vue&type=style&index=0&id=60b0a574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0a574",
  null
  
)

export default component.exports